import React from 'react';
import { Widget } from '../layouts/Widget';
// import LayoutInput from '../layouts/LayoutInput.mjs'; // Unused
import Question from '../../Question.jsx';
import { useQuestionContext } from '../../QuestionContext.jsx';
// import NeuroMessage from '../../../components/NeuroMessage'; // Unused
import '../../../scss/widgets/QuestionsWidget.scss'; // Import the SCSS file

/**
 * QuestionsWidget (Previously Questions.jsx)
 * 
 * Renders a list of questions using the standard Question component.
 */

// No configuration options needed
const options = [];

// eslint-disable-next-line no-unused-vars
const render = (guideData, /* widgetOptions, */ /* props */) => {
  const widget = guideData.questionGroup;
  const page = guideData.page;
  const questions = widget?.questions || [];
  const questionComponents = useQuestionContext();
  
  // The page key is already passed to the Question component through the page prop
  // The Question component will need to be updated separately to use the new message ID format
  
  return (
    <div className="questions-widget-container">
      <div className="questions-widget-content">
        {questions.length > 0 ? (
          questions.map((question) => (
            <Question
              key={question.appkey || question.id}
              component={questionComponents.getQuestionComponent(question.type)}
              page={page}
              questionGroup={widget}
              question={question}
            />
          ))
        ) : (
          <p className="questions-widget-no-questions-message">
            No questions configured for this widget yet.
          </p>
        )}
      </div>
    </div>
  );
};

export default new Widget(
  'QuestionsWidget',
  'Questions Widget',
  'Core', 
  render, 
  options,
  {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 1,
    maxHeight: 12,
    defaultWidth: 12,
    defaultHeight: 3
  }
);